import { Outlet } from 'react-router-dom'
import { MainLayout } from '@ludus/ui'
import { Brand } from './Brand.tsx'
import { HeaderActions } from './HeaderActions.tsx'
import { useConsoleNavItems } from './nav.config.ts'

export function AppLayout() {
  const navItems = useConsoleNavItems()
  return (
    <MainLayout navItems={navItems} brand={<Brand />} headerRight={<HeaderActions />}>
      <Outlet />
    </MainLayout>
  )
}
